export const navigateTo = {
  WALLET: 'wallet',
  HOME: 'home',
  ACCOUNT: 'account',
}
